import { c as _c } from "react/compiler-runtime";
import { Modal } from '@xefi/x-react/modal';
import type { ComponentPropsWithoutRef } from 'react';
type PreviewModalProps = ComponentPropsWithoutRef<typeof Modal>;
export const PreviewModal = t0 => {
  const $ = _c(6);
  let isOpen;
  let props;
  if ($[0] !== t0) {
    ({
      isOpen,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isOpen;
    $[2] = props;
  } else {
    isOpen = $[1];
    props = $[2];
  }
  const t1 = Boolean(isOpen);
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <Modal className="px-4 pt-8" buttonCloseLabel="" isOpen={t1} {...props} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};